import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, BookOpen, MapPin, User } from 'lucide-react';
import { seriesInfo } from '../../data/series';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-cedar-900 border-t border-cedar-700/30 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <div className="flex items-center space-x-3">
                <img 
                  src="/mk-monogram.svg" 
                  alt="M.K. Rivers" 
                  className="h-12 w-12"
                />
                <div className="flex flex-col">
                  <span className="text-lg font-serif font-bold text-fog-100">
                    Memory Keeper
                  </span>
                  <span className="text-sm text-fog-400 -mt-1">
                    Mysteries
                  </span>
                </div>
              </div>
            </Link>
            <p className="text-fog-400 text-sm leading-relaxed">
              {seriesInfo.tagline}
            </p>
            <div className="pt-2">
              <img 
                src="/mk-rivers-signature.svg" 
                alt="M.K. Rivers - Author" 
                className="h-8 w-auto opacity-75"
              />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-fog-100 font-serif font-semibold mb-4">
              Explore
            </h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/books" 
                  className="text-fog-400 hover:text-forest-400 transition-colors text-sm flex items-center space-x-2"
                >
                  <BookOpen className="w-4 h-4" />
                  <span>Books</span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/cedar-falls" 
                  className="text-fog-400 hover:text-forest-400 transition-colors text-sm flex items-center space-x-2"
                >
                  <MapPin className="w-4 h-4" />
                  <span>Cedar Falls</span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/author" 
                  className="text-fog-400 hover:text-forest-400 transition-colors text-sm flex items-center space-x-2"
                >
                  <User className="w-4 h-4" />
                  <span>About M.K. Rivers</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Books */}
          <div>
            <h3 className="text-fog-100 font-serif font-semibold mb-4">
              Books
            </h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/books/fractured-recall" 
                  className="text-fog-400 hover:text-forest-400 transition-colors text-sm"
                >
                  Book 1: Fractured Recall
                </Link>
              </li>
              <li>
                <Link 
                  to="/books/blackwood-mansion" 
                  className="text-fog-400 hover:text-forest-400 transition-colors text-sm"
                >
                  Book 2: The Blackwood Mansion
                  <span className="text-amber-500 text-xs ml-2">Coming 2025</span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/books" 
                  className="text-fog-400 hover:text-forest-400 transition-colors text-sm"
                >
                  All Books →
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter & Connect */}
          <div>
            <h3 className="text-fog-100 font-serif font-semibold mb-4">
              Stay Connected
            </h3>
            <div className="space-y-4">
              <div className="bg-cedar-800/50 p-4 rounded-lg border border-cedar-700/30">
                <div className="flex items-center space-x-2 mb-2">
                  <Mail className="w-4 h-4 text-forest-400" />
                  <span className="text-sm font-medium text-fog-200">
                    Reader Updates
                  </span>
                </div>
                <p className="text-xs text-fog-400 mb-3">
                  Get exclusive content, early access to new releases, and behind-the-scenes insights from Cedar Falls.
                </p>
                <button className="btn btn-primary w-full text-sm">
                  Join Newsletter
                </button>
              </div>
              
              {/* Social Links Placeholder */}
              <div className="text-xs text-fog-500">
                Social media coming soon
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-cedar-700/30 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-fog-500 text-sm">
            © {currentYear} {seriesInfo.author}. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 sm:mt-0">
            <Link to="/privacy" className="text-fog-500 hover:text-fog-400 text-sm">
              Privacy Policy
            </Link>
            <a href="mailto:contact@memorykeepermysteries.com" className="text-fog-500 hover:text-fog-400 text-sm">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};